function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 128.197V1h180v127.197z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#666",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 7",
  d: "M90.886 1.25v127.031M1.25 64.879h179.5"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF0F2",
  d: "M90 128V64h91v64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.261 69.971v1.976c0 .265.177.343.346.343.077 0 .238-.008.33-.03v.788a5.858 5.858 0 0 1-.791.062c-.799 0-.984-.437-.984-1.054v-3.437l1.099-.584v1.093h.676v.843h-.676Zm-1.662 2.952a3.95 3.95 0 0 1-1.138.187c-1.283 0-1.959-.812-1.959-2.03 0-1.21.676-2.03 1.96-2.03.384 0 .783.078 1.137.187l-.154.812c-.346-.11-.576-.156-.853-.156-.66 0-.937.5-.937 1.187s.276 1.187.937 1.187c.277 0 .507-.047.853-.156l.154.812Zm3.969-.976V69.97h.677v-.843h-.677v-1.093l-1.098.584v3.437c0 .617.184 1.054.983 1.054.185 0 .569-.023.792-.062v-.789a1.692 1.692 0 0 1-.331.031c-.169 0-.346-.078-.346-.343Z",
  fill: "#DF0024"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.55 74.104h.621v.168h-.62v.508h.728v.168h-.928v-1.465h.918v.168h-.719v.453Zm1.225.023.106.172h.004l.113-.176.18-.252h.19l-.37.53.379.547h-.22l-.185-.254-.108-.177h-.004l-.112.18-.174.25h-.204l.377-.546-.372-.53h.218l.182.256Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.008 73.85a.435.435 0 0 0-.309.129h-.004l-.019-.108h-.163v1.464h.182v-.49h.004a.416.416 0 0 0 .299.124c.29 0 .422-.247.422-.56 0-.312-.123-.56-.412-.56Zm-.313.245a.386.386 0 0 1 .246-.095c.205 0 .288.183.288.41 0 .228-.083.409-.288.409a.386.386 0 0 1-.246-.093v-.631Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.634 73.871h.163l.019.196h.004a.472.472 0 0 1 .382-.217v.176a.674.674 0 0 0-.386.136v.786h-.182V73.87Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.808 74.827c-.289 0-.378-.168-.382-.379h.729a.913.913 0 0 0 .021-.19c0-.189-.099-.408-.428-.408-.347 0-.513.236-.513.56 0 .322.153.56.539.56.112 0 .218-.012.351-.057l-.021-.133a.845.845 0 0 1-.296.047Zm.186-.512h-.568c.004-.155.087-.34.318-.34.182 0 .259.124.259.236 0 .026-.003.06-.009.104Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.736 74.97c-.14 0-.276-.016-.399-.048l.03-.138c.144.043.271.056.343.056.204 0 .242-.112.242-.168 0-.11-.119-.151-.251-.198-.162-.058-.342-.122-.342-.325 0-.188.163-.3.423-.3.14 0 .233.016.356.048l-.025.138a1.127 1.127 0 0 0-.312-.056c-.184 0-.235.092-.235.155 0 .109.122.152.256.2.162.058.342.122.342.316 0 .205-.17.32-.428.32Zm.557-.048c.123.032.259.047.399.047.258 0 .428-.114.428-.319 0-.194-.18-.258-.342-.316-.134-.048-.256-.091-.256-.2 0-.063.051-.155.235-.155.074 0 .187.017.312.056l.025-.138a1.26 1.26 0 0 0-.356-.047c-.26 0-.424.112-.424.299 0 .203.181.267.343.325.131.046.251.089.251.198 0 .056-.038.168-.242.168a1.27 1.27 0 0 1-.343-.056l-.03.138Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M128.658 78.718h2.186v12.389h-2.186zm3.713 0h.729v12.389h-.729zm2.254 0h.364v12.389h-.364zm1.891 0h2.186v12.389h-2.186zm3.712 0h.729v12.389h-.729zm2.255 0h.729v12.389h-.729zm2.254 0h.364v12.389h-.364zm1.891 0h.364v12.389h-.364zm1.89 0h.729v12.389h-.729zm2.255 0h.729v12.389h-.729zm2.255 0h2.186v12.389h-2.186zm3.712 0h.729v12.389h-.729zm2.255 0h.729v12.389h-.729zm2.255 0h.364v12.389h-.364zm1.89 0h2.186v12.389h-2.186zm3.712 0h.729v12.389h-.729zm-73.8-2.401h12.208v2.289H93.052zm0 9.919h15.26v2.289h-15.26zm0 22.891h41.965v2.289H93.052zm61.04 0h13.734v2.289h-13.734z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DF0024",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 7",
  d: "M90.5 127.5v-63h90v63z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.359,
  strokeLinejoin: "round",
  d: "M1 128.197V1h180v127.197z"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90 128V64h91v64z"
})));

function SvgPrintLabelFourthPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 129,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintLabelFourthPosition);
export default __webpack_public_path__ + "static/media/print-label-fourth-position.e644b92c.svg";
export { ForwardRef as ReactComponent };